import { FIXTURE_SAMPLING_HISTORY } from '../data-access/fixture-sampling-history'
import { BaseQuery } from './BaseQuery'
import {
  fixtureSamplingHistory,
  fixtureSamplingHistoryVariables
} from '../data-access/__generated__/types'

export class FixtureSamplingHistoryQuery extends BaseQuery<
  fixtureSamplingHistory,
  fixtureSamplingHistoryVariables
> {
  query = FIXTURE_SAMPLING_HISTORY
}
